export default {"src":"/_next/static/media/apple-pay-white.f56c0e7c.svg","height":20,"width":49,"blurWidth":0,"blurHeight":0};